<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6 xs6>
                        <v-autocomplete :items="scheme" v-model="filter.scheme" :label="label.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="label.scheme" :error-messages="errors.collect('scheme')" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex md6 xs6>
                        <v-text-field v-model="filter.riskNo" :label="label.riskNo" :error-messages="errors.collect('riskNo')" data-vv-name="riskNo" :data-vv-as="label.riskNo"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
        <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="primary" @click.native="doPrint">
            <span>Print Preview</span>
              <v-icon right dark>mdi-printer</v-icon>
          </v-btn>
          <v-btn color="primary" @click.native="doNew">
            New Package Standard Risk Text<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.scheme }} </td>
                <td class="text-xs-left">{{ row.item.riskNo }} </td>
                <td class="text-xs-left">{{ row.item.stdRiskTxtRef }} </td>
                <td class="text-xs-left">{{ row.item.busCls }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the Package Standard Risk Text?</p>
        <div class="queryValue">Scheme: {{selected.scheme}}<br/>
          Risk No.: {{selected.riskNo}}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      scheme: [],
      busCls: [],
      stdRiskTxtRef: [],
      items: [],
      dto: {
        scheme: null,
        riskNo: null,
        format: null,
        customName: null,
        sendEmail: null
      },
      label: {
        scheme: 'Scheme',
        riskNo: 'Risk No.',
        stdRiskTxtRef: 'Standard Risk Text Reference',
        busCls: 'Default Business Class'
      },
      filter: {
        scheme: null,
        riskNo: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Scheme', align: 'left', value: 'scheme' },
        { text: 'Risk No.', align: 'left', value: 'riskNo' },
        { text: 'Standard Risk Text Reference', align: 'left', value: 'stdRiskTxtRef' },
        { text: 'Default Business Class', align: 'left', value: 'busCls' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selected: {
        scheme: null,
        riskNo: null,
        stdRiskTxtRef: null,
        busCls: null
      },
      PkgSRTxtMenuLink: {},
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('pkgStdRiskTxtInit')
    this.fetchData(true)
    this.doInit()
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('scheme')
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getPkgStdRiskTxtList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  scheme: datamap.scheme,
                  riskNo: datamap.riskNo,
                  stdRiskTxtRef: datamap.stdRiskTxtRef,
                  busCls: datamap.busCls
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.scheme = null
      this.filter.riskNo = null
      this.filter.stdRiskTxtRef = null
      this.filter.busCls = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeletePkgStdRiskTxt
          const expand = {
            scheme: data.scheme,
            riskNo: data.riskNo
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selected.scheme = data.scheme
          this.selected.riskNo = data.riskNo
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.riskNo) {
        const apiURI = this.menu.deletePkgStdRiskTxt
        if (apiURI) {
          const expand = {
            scheme: this.selected.scheme,
            riskNo: this.selected.riskNo
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        scheme: null,
        riskNo: null,
        busCls: null,
        stdRiskTxtRef: null
      }
      sessionStorage.setItem('pkgStdRiskTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDRISKTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdRiskTxtReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        scheme: data.scheme,
        riskNo: data.riskNo,
        busCls: data.busCls,
        stdRiskTxtRef: data.stdRiskTxtRef
      }
      sessionStorage.setItem('pkgStdRiskTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDRISKTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdRiskTxtReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        scheme: data.scheme,
        riskNo: data.riskNo,
        busCls: data.busCls,
        stdRiskTxtRef: data.stdRiskTxtRef
      }
      sessionStorage.setItem('pkgStdRiskTxt', JSON.stringify(commit))
      this.$store.commit('PKGSTDRISKTXT_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgStdRiskTxtReview' })
    },
    async doPrint() {
      this.doExportPkgSRTxtRecord()
    },
    async doExportPkgSRTxtRecord() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.dto.scheme = this.filter.scheme
          this.dto.riskNo = ''
          this.dto.format = 'PDF'
          this.dto.customName = ''
          this.dto.sendEmail = false
          let messageFilters = clone(this.dto)
          await this.$http.post(apiURI, messageFilters)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgStdRiskTxt.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
